import React from "react";
import { Box, Grid } from "@material-ui/core";
import periodOptions from "./data";
import { Typography } from "../../../../../../common/components/libs";
import PeriodOption from "./periodOption";
import { observer } from "mobx-react";


interface Props{

}
const PeriodsTab = (props: Props) => {

    return <>
        <div>
            <Grid container style={{
                maxWidth: 400,
                marginTop: 5
            }}>
                {periodOptions.map(period => {
                    return <PeriodOption period={period}/>
                })}
            </Grid>
        </div>
    </>
}


export default observer(PeriodsTab)
